import React from "react";
import style from "./NewsVideo.module.scss";
import { useSignal } from "@preact/signals-react";
import ReactPlayer from "react-player/youtube";
import { LeftCircleOutlined } from "@ant-design/icons";
import { VideoPlayIcon } from "../components/VideoPlayIcon/VideoPlayIcon";
export function NewsVideo(props) {
  var isVideoPlaying = useSignal(false);
  function playVideo() {
    isVideoPlaying.value = true;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style.newsVideoBox
  }, /*#__PURE__*/React.createElement("div", {
    className: style.video
  }, props.isFromList && /*#__PURE__*/React.createElement("div", {
    className: style.backIcon,
    onClick: props.back
  }, /*#__PURE__*/React.createElement(LeftCircleOutlined, {
    style: {
      fontSize: "34px"
    }
  })), /*#__PURE__*/React.createElement(ReactPlayer, {
    url: props.video_url,
    width: "100%",
    height: "100%",
    playing: isVideoPlaying.value,
    controls: true,
    light: true,
    playIcon: /*#__PURE__*/React.createElement(VideoPlayIcon, {
      className: "newsVideoPlayIcon"
    }),
    onClickPreview: playVideo
  })), /*#__PURE__*/React.createElement("div", {
    className: style.videoInfo
  }, /*#__PURE__*/React.createElement("p", {
    className: style.videoTitle
  }, props.video_headline), /*#__PURE__*/React.createElement("div", {
    className: style.videoBrand
  }, /*#__PURE__*/React.createElement("img", {
    src: props.source.source_icon
  }), /*#__PURE__*/React.createElement("span", null, props.source.source_text))));
}